<template>
    <div class="flex w-full gap-5 h-full forbidden-name-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.forbiddenName.header') }}</h2>
                <CustomButton :label="$t('message.forbiddenName.addNewButton')" @click="addNewName"/>
            </div>
            <ForbiddenNameTable ref="forbiddenNameTable" v-model="selectedName" @showForm="showForm"/>
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? $t('message.forbiddenName.headerNew') : $t('message.forbiddenName.headerEdit') }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <ForbiddenNameForm :selectedName="selectedName" @change-element="reloadTable"
                @createMode="(val) => createMode = val" @hideForm="hideForm"/>
        </div>
    </div>
</template>

<script>
import ForbiddenNameTable from "./components/ForbiddenNameTable";
import ForbiddenNameForm from "./components/ForbiddenNameForm";
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";

export default {
    name: "ForbiddenNameListView",
    components: {
        LibyanOrnament,
        ForbiddenNameTable,
        ForbiddenNameForm,
        CustomButton,
        CustomIconButton,
    },
    data() {
        return {
            selectedName: {},
            createMode: true,
        }
    },
    mounted() {
        this.selectedName = this.getClearName();
    },
    methods: {
        getClearName() {
            return {
                id: null,
                description: "",
            };
        },
        reloadTable() {
            this.$refs.forbiddenNameTable.reloadTable();
            this.selectedName = this.getClearName();
        },
        addNewName() {
            ScrollToUtils.scrollToElement();
            this.$refs.forbiddenNameTable.addNewName();
            this.selectedName = this.getClearName();
            this.showForm();
        },
        showForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
        },
        hideForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/theme/mytheme/variables";
.forbidden-name-view {
    @media screen and (max-width: 1200px) {
        flex-direction: column;
        align-items: center;
        .section-table, .section-details {
            width: 90% !important;
        }
        .close-form-button {
            display: none;
        }
    }
}
.section-table, .section-details {
    transition: 1s ease-in-out;
}
.section-details {
    height: calc(100vh - 40px - $top-bar-height);;
    overflow-y: auto;
    width: 0;
}
</style>
